import { Link, Navigate, useParams } from "react-router-dom"
import Seo from "@/components/Seo"
import { getCourse } from "@/data/courses"

const SITE = "https://www.jero-onetechnologies.com"

const List = ({ title, items, testid }) => (
  <div className="rounded-3xl border border-brand-green/15 bg-brand-mid p-8" data-testid={testid}>
    <h2 className="font-display text-3xl font-black text-brand-light">{title}</h2>
    <ul className="mt-5 space-y-3">
      {items.map((x) => (
        <li key={x} className="flex gap-3 text-sm text-brand-light/85"><span className="text-brand-green-light">▸</span>{x}</li>
      ))}
    </ul>
  </div>
)

export default function CoursePage() {
  const { slug } = useParams()
  const c = getCourse(slug)
  if (!c) return <Navigate to="/training" replace />
  const schema = {
    "@context": "https://schema.org",
    "@type": "Course",
    name: `${c.title} Training`,
    description: c.summary,
    url: `${SITE}/training/${c.slug}`,
    provider: { "@type": "Organization", name: "Jero-One Technologies Inc.", sameAs: SITE },
    educationalLevel: c.level,
    timeRequired: c.duration,
    hasCourseInstance: { "@type": "CourseInstance", courseMode: ["onsite", "online"], location: "Kampala & Entebbe, Uganda" },
  }
  return (
    <div className="bg-[#0A0F0B]" data-testid={`course-${c.slug}`}>
      <Seo title={`${c.title} Training Kampala | Jero-One Academy`} description={c.summary.slice(0, 158)} path={`/training/${c.slug}`} schema={schema} />
      <section className="mx-auto max-w-6xl px-6 py-20 md:px-14">
        <Link to="/training" className="text-sm font-semibold text-brand-green-light hover:underline">← All courses</Link>
        <div className="mt-6 font-mono text-xs tracking-widest text-brand-green-light">JERO-ONE ACADEMY · {c.track.toUpperCase()}</div>
        <h1 className="mt-3 font-display text-5xl font-black leading-none text-brand-light md:text-6xl">{c.title.toUpperCase()} TRAINING</h1>
        <p className="mt-6 max-w-3xl text-lg leading-relaxed text-brand-muted">{c.summary}</p>
        <div className="mt-8 flex flex-wrap gap-3 text-sm">
          {[["Level", c.level], ["Duration", c.duration], ["Format", "Classroom (Kampala/Entebbe), on-site or online"]].map(([k, v]) => (
            <div key={k} className="rounded-xl border border-brand-green/20 bg-brand-navy px-5 py-3"><span className="text-brand-muted">{k}: </span><span className="font-semibold text-brand-light">{v}</span></div>
          ))}
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          <List title="WHAT YOU'LL LEARN" items={c.outcomes} testid="course-outcomes" />
          <List title="COURSE MODULES" items={c.modules} testid="course-modules" />
        </div>
        <div className="mt-6 rounded-3xl border border-brand-green/15 bg-brand-navy p-8">
          <h2 className="font-display text-3xl font-black text-brand-light">WHO IS IT FOR?</h2>
          <p className="mt-3 text-brand-muted">{c.audience} Corporate group training for your team is available on request.</p>
          <Link to="/contact" className="mt-6 inline-block rounded-xl bg-brand-green px-7 py-3.5 font-bold text-brand-light transition-colors hover:bg-brand-green-light" data-testid="course-enquire-btn">Enquire about this course →</Link>
        </div>
      </section>
    </div>
  )
}
